import { render, staticRenderFns } from "./creditsAndRefunds.vue?vue&type=template&id=54e8f39b&scoped=true&"
import script from "./creditsAndRefunds.vue?vue&type=script&lang=js&"
export * from "./creditsAndRefunds.vue?vue&type=script&lang=js&"
import style0 from "./creditsAndRefunds.vue?vue&type=style&index=0&id=54e8f39b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8f39b",
  null
  
)

export default component.exports